import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { Link } from 'react-router-dom'
import type { TipologiaImpianto } from '@praticheenergia/domain'
import { ETICHETTA_TIPOLOGIA } from '../home/ripartizione'
import { ETICHETTA_STATO_DICHIARAZIONE } from './stato-dichiarazione'
import type { RigaElenco } from './impianti.api'

// Doppia traccia di stato: la dichiarazione AD-1 e le accise mensili sono due
// adempimenti distinti, ognuno con la sua colonna.
export const COLONNE_IMPIANTI: GridColDef[] = [
  { field: 'operatore', headerName: 'Operatore', width: 140, filterable: true },
  { field: 'codiceDichiarazione', headerName: 'Codice Dichiarazione', width: 170 },
  { field: 'codiceImpianto', headerName: 'Codice impianto', width: 150 },
  { field: 'ragioneSociale', headerName: 'Ragione sociale', flex: 1, minWidth: 200, filterable: true },
  {
    field: 'tipologia',
    headerName: 'Tipologia',
    width: 220,
    valueFormatter: (v: TipologiaImpianto) => ETICHETTA_TIPOLOGIA[v],
  },
  {
    field: 'statoUltimaDichiarazione',
    headerName: 'Stato ultima dichiarazione',
    width: 200,
    valueFormatter: (v: string) =>
      ETICHETTA_STATO_DICHIARAZIONE[v as keyof typeof ETICHETTA_STATO_DICHIARAZIONE] ?? v,
  },
  { field: 'statoAcciseMensili', headerName: 'Stato accise mensili', width: 180 },
  {
    field: 'azione',
    headerName: 'Azione',
    width: 120,
    sortable: false,
    filterable: false,
    renderCell: (params: GridRenderCellParams<RigaElenco>) => <Link to={`../impianti/${params.row.id}`}>Dettagli</Link>,
  },
]
